import { Range } from "@pdfking/tfunc"

import { LOREM_WORDS } from "#constants"
import type { RandomStream } from "#internal"

import { RandomPick } from "../random/RandomPick"
import { Capitalize } from "./Capitalize"

// `count` words of a title, each capitalized
export const LoremTitle = (random: RandomStream, count: number): string =>
  [...Range(1, count)].map(() => Capitalize(RandomPick(random, LOREM_WORDS))).join(" ")

// Endless lorem prose: sentences of random words, some commas, a capital after
// every full stop
export const LoremProse = function* (random: RandomStream): Generator<string, never> {
  let sentence_start = true
  while (true) {
    const word = RandomPick(random, LOREM_WORDS)
    const mark = random()
    const text = sentence_start ? Capitalize(word) : word
    sentence_start = mark < 0.08
    yield mark < 0.08 ? `${text}.` : mark < 0.15 ? `${text},` : text
  }
}
